import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const adminCancelOrder = id =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: `/order/cancel/${id}`,
  });
